import type { FeatureFlagKey } from "@redotech/feature-flags-model/keys";
import { memo, type ReactNode } from "react";
import { useTeamFeatureFlag } from "./use-team-feature-flag";

export const FeatureFlagGate = memo(function FeatureFlagGate({
  flagKey,
  children,
}: {
  flagKey: FeatureFlagKey;
  children: ReactNode;
}) {
  const { enabled } = useTeamFeatureFlag(flagKey);

  if (!enabled) {
    return null;
  }

  return <>{children}</>;
});
